import { render, staticRenderFns } from "./payment_receive.vue?vue&type=template&id=8f2b9a70&scoped=true"
import script from "./payment_receive.vue?vue&type=script&lang=js"
export * from "./payment_receive.vue?vue&type=script&lang=js"
import style0 from "./payment_receive.vue?vue&type=style&index=0&id=8f2b9a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2b9a70",
  null
  
)

export default component.exports